/** A capability an active app extends, identified by a versioned slug (e.g. `stored_value_authorize@v1`). */
export interface ActiveAppExtendable {
  slug: string;
  [key: string]: unknown;
}

/**
 * An app that is active/installed for the current tenant, as returned by
 * `GET /v2/b2b/apps/activeapps`.
 */
export interface ActiveApp {
  appRefid: string;
  extendables?: ActiveAppExtendable[];
  [key: string]: unknown;
}

/**
 * Extendable slug used to detect the stored value (gift card) app. Slugs are
 * version-tagged (e.g. `stored_value_authorize@v1`), so matching ignores the
 * `@version` suffix.
 */
export const STORED_VALUE_AUTHORIZE_SLUG = 'stored_value_authorize';
